export function isPhotoFile(value) {
  return value instanceof File || value instanceof Blob;
}
